import { logger } from "@sentry/svelte";
import { formatDiagnostics } from "@libs/diagnostics/formatDiagnostics.js";

export const diagnostics = formatDiagnostics(console, (type, ...data) => {
	logger[type](data.map(String).join(" "));
	return data;
});
